import { render } from "./UsersIndex.vue?vue&type=template&id=163709aa"
import script from "./UsersIndex.vue?vue&type=script&lang=js"
export * from "./UsersIndex.vue?vue&type=script&lang=js"

import "./UsersIndex.vue?vue&type=style&index=0&id=163709aa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__